import {provideEffects} from "@ngrx/effects";
import {provideStore} from "@ngrx/store";
import {provideStoreDevtools} from "@ngrx/store-devtools";
import {
  InhibitionConnectivityEffect,
  inhibitionConnectivityFeatureKey,
  inhibitionConnectivityReducer, ProviderConnectivityEffect,
  providerConnectivityFeatureKey,
  providerConnectivityReducer, StationFollowerEffect,
  stationFollowerFeatureKey,
  stationFollowerReducer
} from 'src/app/shared/store';

export const provideAppStore = () => [
  provideStore({
    [providerConnectivityFeatureKey]: providerConnectivityReducer,
    [inhibitionConnectivityFeatureKey]: inhibitionConnectivityReducer,
    [stationFollowerFeatureKey]: stationFollowerReducer,
  }),
  provideEffects([
    ProviderConnectivityEffect,
    InhibitionConnectivityEffect,
    StationFollowerEffect,
  ]),
  provideStoreDevtools({ maxAge: 25 }),
];
